































import { Vue, Component } from 'vue-property-decorator';
import VoteList from '../components/VoteListTwo.vue';
import { Picker, Popup } from 'vant';
import { getBaseInfo } from '../api';
Vue.use(Picker).use(Popup);
@Component({
  components: {
    VoteList,
  },
})
export default class Home extends Vue {
  baseInfo: any = {};
  active = 0;
  tempValue = '';
  searchWords: string = '';
  selectValue = '';
  async created() {
    const res = await getBaseInfo();
    this.baseInfo = res.data;
  }
  onConfirm(e: any) {
    this.selectValue = e;
    this.searchWords = '';
    this.tempValue = '';
  }
  handleClickSearch() {
    this.searchWords = this.tempValue;
  }
  enterDetailPage(item: any) {
    this.$router.push({
      path: 'detail',
      query: {
        id: String(item.id),
        type: String(1),
      },
    });
  }
}
